import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { Store } from '@ngrx/store';
import { State } from '@core/ngrx';
import { NousToken } from '@app/shared/models/nous-token.model';


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly appState$ = inject<Store<State>>(Store);


  getTokenFromStorage(): NousToken {
    return this.localStorageService.read('token') as NousToken;
  }

  setToken(token: NousToken) {
    this.localStorageService.write('token', token);
  }
}
